import { Injectable } from '@angular/core';
import {
  BookingRepository,
  CategoriesRepository,
  ServicesRepository,
  ServiceRequestsRepository,
} from '@app/store';
import { LocationRepository } from '@app/store/location.repository';
import { NotificationsRepository } from '@app/store/notifications.repository';
import { TutorialsRepository } from '@app/store/tutorials.repository';
import { WeatherRepository } from '@app/store/weather.repository';
import { environment } from '@env/environment';
import { deleteRequestResult } from '@ngneat/elf-requests';
import { DataPreloadService } from '../data-preload/data-preload.service';

@Injectable({ providedIn: 'root' })
export class StoreCleanupService {
  constructor(
    private bookingRepo: BookingRepository,
    private categoriesRepo: CategoriesRepository,
    private locationRepo: LocationRepository,
    private notificationsRepo: NotificationsRepository,
    private servicesRepo: ServicesRepository,
    private serviceRequestsRepo: ServiceRequestsRepository,
    private dataPreloadService: DataPreloadService,
  ) {}

  clearAllStores(): void {
    // Reset data loading state first
    this.dataPreloadService.resetDataLoadingState();

    // Clear all repositories
    this.bookingRepo.clear();
    this.categoriesRepo.clear();
    this.locationRepo.clear();
    this.notificationsRepo.clear();
    this.servicesRepo.clear();
    this.serviceRequestsRepo.clear();
    deleteRequestResult(['categories']);
    deleteRequestResult(['bookings']);
    deleteRequestResult(['locations']);

    // Clear local storage except for specific items you want to keep
    const itemsToKeep = new Set([
      'translocoLang',
      environment.localStorageKeyPrefix + 'settings',
    ]); // Add any items you want to preserve
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && !itemsToKeep.has(key)) {
        localStorage.removeItem(key);
      }
    }

    // Clear session storage
    sessionStorage.clear();
  }
}
